export namespace ErrorCode {
  /**
   * ブロックチェーン系
   */
  export const REGISTER_ERROR = "[B90000] : API呼び出しに失敗しました。"
  export const EXPLANATION_ERROR = "[B90001] : API呼び出しに失敗しました。"
  export const SIGN_ERROR = "[B90002] : API呼び出しに失敗しました。"
  export const DOWNLOAD_ERROR = "[B90004] : API呼び出しに失敗しました。"

  export const APPROVAL_FLOW_ERROR = "[B90008] : API呼び出しに失敗しました。"
}
